import React, { useState, useEffect } from 'react';
import { ascending } from 'd3-array';
import ChartProgression from './ChartProgression';
import { fetchData } from './FetchData';

function filterData(data) {
  return data.filter((d) => {
    return true;
  });
}

function prepareChartProgressionData(data) {
  // usually more wrangling is required but the example data is simple
  return data;
}

const useData = (dataSet) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchNewData = async () => {
      try {
        setLoading(true);
        setError(false);
        const data = await fetchData(dataSet);
        const dataClean = filterData(data);
        setData(prepareChartProgressionData(dataClean));
        setLoading(false);
      } catch (err) {
        console.log(err);
        setError(err);
        setLoading(false);
      }
    };
    fetchNewData();
  }, [dataSet]);

  return [data, loading, error];
};

const ChartProgressionData = () => {
  const [dataSet, setDataSet] = useState('dataProgression');
  const [data, loading, error] = useData(dataSet);

  return (
    <>
      <ChartProgression data={data} loading={loading} error={error} />
    </>
  );
};

export default ChartProgressionData;
